module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-06.96b3c25e.jpg";